import React from 'react';
export const FooterBar = () => {
  return <footer className="w-full flex flex-col items-center pt-8 pb-12 px-4 z-10 relative" data-id="element-10">
      <div className="w-4/5 max-w-md h-px bg-we-gold opacity-40 mb-8" data-id="element-11"></div>
      <p className="text-we-gold text-sm mb-2" data-id="element-12">@wealthengine.ar</p>
      <p className="text-white text-xs opacity-50 font-light" data-id="element-13">
        Todos los derechos reservados
      </p>
    </footer>;
};